import React from 'react';

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-[#FDFAF4] pb-16">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-[#B8922A] mb-4">
            Informations légales
          </p>
          <h1
            className="text-5xl md:text-6xl font-light mb-4 text-[#5C2018]"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            data-testid="mentions-title"
          >
            Mentions légales
          </h1>
          <p className="text-[#332724]/70 font-light text-sm">
            Dernière mise à jour : juin 2026
          </p>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-2xl border border-gold space-y-10 text-[#332724] font-light leading-relaxed">
          {/* Éditeur */}
          <section data-testid="section-editeur">
            <h2
              className="text-2xl mb-4 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              1. Éditeur du site
            </h2>
            <div className="space-y-2 text-sm">
              <p><strong className="text-[#5C2018]">Raison sociale :</strong> MAISON HARMONY</p>
              <p><strong className="text-[#5C2018]">Nom commercial :</strong> Harmony Parfumerie</p>
              <p><strong className="text-[#5C2018]">Forme juridique :</strong> SASU (Société par Actions Simplifiée Unipersonnelle)</p>
              <p><strong className="text-[#5C2018]">Capital social :</strong> 100,00 €</p>
              <p><strong className="text-[#5C2018]">Adresse :</strong> Polygone Béziers, Local 221, Avenue Président Wilson, 34500 Béziers</p>
              <p><strong className="text-[#5C2018]">SIREN :</strong> 928 654 946</p>
              <p><strong className="text-[#5C2018]">SIRET :</strong> 928 654 946 00013</p>
              <p><strong className="text-[#5C2018]">RCS :</strong> Montpellier B 928 654 946</p>
              <p><strong className="text-[#5C2018]">N° TVA intracommunautaire :</strong> FR11928654946</p>
              <p><strong className="text-[#5C2018]">Code APE / NAF :</strong> 47.75Z — Commerce de détail de parfumerie et de produits de beauté en magasin spécialisé</p>
              <p><strong className="text-[#5C2018]">Téléphone :</strong> <a href="tel:0467215708" className="text-[#1E7A6A] hover:underline">04 67 21 57 08</a></p>
              <p><strong className="text-[#5C2018]">Email :</strong> <a href="mailto:contact@maisonharmony.com" className="text-[#1E7A6A] hover:underline">contact@maisonharmony.com</a></p>
            </div>
          </section>

          {/* Directeur publication */}
          <section data-testid="section-directeur">
            <h2
              className="text-2xl mb-4 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              2. Directeur de la publication
            </h2>
            <p className="text-sm">
              Madame Hayat BOUSDIRA, en sa qualité de Présidente de la SASU
              MAISON HARMONY.
            </p>
          </section>

          {/* Hébergeur */}
          <section data-testid="section-hebergeur">
            <h2
              className="text-2xl mb-4 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              3. Hébergement du site
            </h2>
            <p className="text-sm">
              Le site est hébergé par <strong>Emergent Labs</strong>, infrastructure
              cloud sécurisée. Pour toute question relative à l'hébergement, vous pouvez
              contacter l'éditeur à l'adresse <a href="mailto:contact@maisonharmony.com" className="text-[#1E7A6A] hover:underline">contact@maisonharmony.com</a>.
            </p>
          </section>

          {/* Propriété intellectuelle */}
          <section data-testid="section-propriete">
            <h2
              className="text-2xl mb-4 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              4. Propriété intellectuelle
            </h2>
            <p className="text-sm mb-3">
              L'ensemble des éléments présents sur le site harmony-parfumerie.fr — textes,
              photographies, logos, identités visuelles, dénominations, vidéos, illustrations,
              icônes et tout autre contenu — sont la propriété exclusive de la SASU MAISON
              HARMONY ou de ses partenaires.
            </p>
            <p className="text-sm">
              Toute reproduction, représentation, modification, publication, adaptation totale
              ou partielle des éléments du site, quel que soit le moyen ou le procédé
              utilisé, est interdite sans autorisation écrite préalable.
            </p>
          </section>

          {/* Liens hypertextes */}
          <section data-testid="section-liens">
            <h2
              className="text-2xl mb-4 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              5. Liens hypertextes
            </h2>
            <p className="text-sm">
              Le site harmony-parfumerie.fr peut contenir des liens vers des sites tiers
              (Square, PayPal, Instagram, Facebook, TikTok, Visit&apos;insolite, etc.).
              MAISON HARMONY n'exerce aucun contrôle sur ces sites et décline toute
              responsabilité quant à leur contenu.
            </p>
          </section>

          {/* Produits cosmétiques */}
          <section data-testid="section-cosmetiques">
            <h2
              className="text-2xl mb-4 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              6. Produits cosmétiques & parfumerie
            </h2>
            <p className="text-sm mb-3">
              Les parfums et produits cosmétiques commercialisés par Harmony Parfumerie sont
              conformes au <strong>Règlement (CE) n°1223/2009</strong> relatif aux produits
              cosmétiques. Chaque produit fait l'objet d'un dossier d'information et est
              notifié sur le portail européen CPNP (Cosmetic Products Notification Portal).
            </p>
            <p className="text-sm">
              Les informations relatives aux ingrédients (liste INCI), aux allergènes (26
              substances réglementées) et aux précautions d'emploi sont disponibles sur
              chaque étiquette produit et sur demande en boutique.
            </p>
          </section>

          {/* Médiation conso */}
          <section data-testid="section-mediation">
            <h2
              className="text-2xl mb-4 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              7. Médiation de la consommation
            </h2>
            <p className="text-sm mb-3">
              Conformément aux articles L.611-1 et suivants du Code de la consommation, le
              consommateur a la possibilité de recourir gratuitement à un médiateur de la
              consommation en cas de litige avec MAISON HARMONY.
            </p>
            <p className="text-sm">
              Plateforme européenne de règlement en ligne des litiges :{' '}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1E7A6A] hover:underline"
              >
                ec.europa.eu/consumers/odr
              </a>
            </p>
          </section>

          {/* Droit applicable */}
          <section data-testid="section-droit">
            <h2
              className="text-2xl mb-4 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              8. Droit applicable
            </h2>
            <p className="text-sm">
              Le présent site et les présentes mentions légales sont soumis au droit français.
              En cas de litige et à défaut de résolution amiable, les tribunaux français
              seront seuls compétents.
            </p>
          </section>

          {/* Achat en ligne — Retrait & Livraison */}
          <section data-testid="section-achat-retrait">
            <h2
              className="text-2xl mb-4 text-[#5C2018]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              9. Achat en ligne — Retrait & Livraison
            </h2>
            <p className="text-sm mb-3">
              Lors du passage de commande sur notre boutique en ligne, le client choisit son mode de récupération :
            </p>
            <ul className="text-sm list-disc list-inside space-y-2 mb-4">
              <li>
                <strong>Retrait en boutique (Click &amp; Collect)</strong> — gratuit. Le client s'engage à venir
                récupérer sa commande au point de vente Harmony Parfumerie (14 Avenue Sergent Bobillot, 34500 Béziers)
                aux horaires d'ouverture. <strong>Aucune expédition n'est effectuée pour les commandes Click &amp; Collect :
                il appartient exclusivement au client de se déplacer en boutique pour retirer sa commande.</strong>
              </li>
              <li>
                <strong>Livraison à domicile</strong> — 8,90€ (Colissimo), offerte dès 60€ d'achat. Cette option doit
                être <strong>explicitement choisie et cochée par le client</strong> au moment du paiement. Seules les
                commandes pour lesquelles l'option « Livraison » a été sélectionnée donnent lieu à une expédition à
                l'adresse renseignée.
              </li>
            </ul>
            <p className="text-sm mb-3">
              <strong>Photos non contractuelles :</strong> les visuels présentés sur le site sont indicatifs.
              La présentation des produits (flacons, coffrets, accessoires) peut varier selon les arrivages
              et les options choisies en boutique. Le client ne peut se prévaloir d'une variation de présentation
              pour annuler sa commande.
            </p>
            <p className="text-sm">
              Les commandes en Click &amp; Collect non retirées au bout de <strong>30 jours</strong> sans
              manifestation du client pourront être remises en stock sans remboursement automatique. Nous
              vous invitons à nous contacter à tout moment au 04 67 21 57 08 ou par email pour toute question.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
